export default {
  items: [
    /*
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer'
    },
    */
    /*
    {
      name: 'Financeiro',
      url: '/financeiro',
      icon: 'cui-dollar'
    },
    */
    /*
    {
      name: 'Cobrança',
      url: '/charge',
      icon: 'fa fa-handshake-o'
    }, */
    /*
    {
      name: 'Cancelamentos',
      url: '/cancellations',
      icon: 'fa fa-times-circle'
    },
    */
    {
      name: 'e-commerces',
      url: '/ecommerces',
      icon: 'icon-basket'
    },
    /*
    {
      title: true,
      name: 'Visões',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    */
    /*
    {
      name: 'Protocolos',
      url: '/whatsapp-protocols',
      icon: 'fa fa-list-alt'
    },
    */
    /*
    {
      name: 'WhatsApp',
      url: '/whatsapp-contacts',
      icon: 'fa fa-whatsapp'
    },
    */
    {
      name: 'Atendimento',
      url: '/customerService',
      icon: 'fa fa-users'
    },
    {
      name: 'Validações',
      url: '/validations',
      icon: 'fa fa-check-circle',
      badge: {
        variant: 'info',
        text: '0'
      }
    },
    {
      name: 'Pedidos',
      url: '/orders',
      icon: 'fa fa-cart-arrow-down'
    }
    /*
    {
      name: 'Configurações',
      url: '/settings',
      class: 'mt-auto',
      icon: 'fa fa-cog'
    }
    */
  ]
}



// WEBPACK FOOTER //
// ./src/_nav.js